import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ElementRef, Renderer2 } from '@angular/core';
import { CoreService } from '../../../services/core.service';
import { CommonModule } from '@angular/common';
import { map, catchError, take } from "rxjs/operators";
import { forkJoin, of } from "rxjs";
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeEl from '@angular/common/locales/el';
import { LOCALE_ID } from '@angular/core';

@Component({
  selector: 'app-facebook-story',
  imports: [NgIf, CommonModule],
  providers: [DatePipe, { provide: LOCALE_ID, useValue: 'en' }],
  templateUrl: './facebook-story.component.html',
  styleUrl: './facebook-story.component.scss'
})
export class FacebookStoryComponent implements OnInit {

  id: string | null = null;
  companyID: number = 0;
  siteDomain: string = 'dummy.view';
  switchboardImage: number = 0;
  mainImageUrl: string = '';
  postFeed: string = '';
    thumbnailFilePath: string = '';
  postTitle: string = '';
  postDescription: string = '';
  articleUrl: string = '';
  scheduledFor: Date | null = null;
  formattedDate: string = '';

  constructor(
    private http: HttpClient,
    private readonly coreService: CoreService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private datePipe: DatePipe,
    private elRef: ElementRef,
    private renderer: Renderer2
  ) { }

  ngOnInit() {
    //window.location.reload(); 

    this.companyID = this.coreService.user?.companyID || 0;
    this.id = this.route.snapshot.paramMap.get("id");
    if (this.id) {
      this.loadPost(this.id);
    }
  }

  loadPost(id: string): void {
    this.coreService.getData(`/manual-post/editPost/${this.companyID}/${id}`)
      .pipe(take(1))
      .subscribe((res: any) => {
        if (!res) {
          this.coreService.showSnackbar("Post not found.");
          return;
        }
        // console.log(res)
        this.siteDomain = res.Domain.replace('https://www.', '');
        if (res.switchboard_img != null) {
          this.switchboardImage = 1;
        }

        this.mainImageUrl = this.switchboardImage == 1 ? res.switchboard_img : res.image_array[0];
        this.thumbnailFilePath = res.thumbnail_file_path;
        this.postFeed = res.feed;
        this.postTitle = res.rss_title;
        this.postDescription = res.rss_description;
        const maxChars = 250;
        this.postDescription = res.rss_description.length > maxChars
          ? res.rss_description.substring(0, maxChars) + '...'
          : res.rss_description;
        this.articleUrl = res.article_url;
        this.scheduledFor = new Date(res.scheduled_for);
        this.formattedDate = this.datePipe.transform(this.scheduledFor, 'd MMMM YYYY') || '';
        const element = this.elRef.nativeElement.querySelector('.story');
        this.renderer.removeClass(element, 'hidden');
      });
  }

}
